import { useCallback, useEffect, useState } from 'react';
import { InfiniteCanvasState } from 'src/slices/infinite-canvas';
import { useDispatch, useSelector } from 'src/store';
import { thunks } from 'src/thunks/infinite-canvas';
import { InfiniteCanvasDto } from 'src/types/infinite-canvas-dto';
import { useApiRequest } from './use-api-request';

export const useInfiniteCanvases = (teamId?: string) => {
  const dispatch = useDispatch();
  const canvases = useSelector((state: any) => (state.infiniteCanvas as InfiniteCanvasState).listInfiniteCanvases);

  const [iCanvases, setICanvases] = useState<InfiniteCanvasDto[]>([]);

  // Use centralized API request management
  const { isLoading, isUnauthorized, hasFetched, refetch } = useApiRequest(
    async () => {
      if (!teamId) throw new Error('Team ID is required');
      await dispatch(thunks.listInfiniteCanvases(teamId));
      return canvases; // Return the canvases data
    },
    {
      requestKey: `listInfiniteCanvases-${teamId}`,
      autoFetch: !!teamId, // Only auto-fetch if teamId is provided
      dependencies: [teamId],
    },
  );

  // Sync Redux state with local state
  useEffect(() => {
    if (canvases) {
      setICanvases([...(canvases[teamId ?? ''] ?? [])]);
    }
  }, [canvases, teamId]);

  return {
    iCanvases,
    getCanvases: refetch,
    isLoading,
    isUnauthorized,
  };
};
